module.exports = __webpack_public_path__ + "static/img/menu-logistics-automation.ca63f4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu-logistics-automation.jpg
// module id = 8asR
// module chunks = 1